import { render, staticRenderFns } from "./comDetail.vue?vue&type=template&id=a68e77c8&scoped=true"
import script from "./comDetail.vue?vue&type=script&lang=js"
export * from "./comDetail.vue?vue&type=script&lang=js"
import style0 from "./comDetail.vue?vue&type=style&index=0&id=a68e77c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a68e77c8",
  null
  
)

export default component.exports